import styled from 'styled-components';

import { ScrollContainer as BaseScrollContainer, Wrap as BaseWrap } from './styled.base';

export * from './styled.base';

export const ScrollContainer = styled(BaseScrollContainer)`
  padding-top: 5.75rem;
`;

export const Wrap = styled(BaseWrap)`
  ${Styles.desktop`
    margin-bottom: 3rem;
  `}
`;
